import { newLogger } from "@/utils/util";
import StoreCore from "@/store/StoreCore";

let logger = newLogger("ChangeThis");

const urls = {
  counter: "/enterprise/counter",
  close: `enterprise/counter/close`,
};

const initState = () => {
  return {
    counters: [],
  };
};

const storeCore = new StoreCore();
const actions = {
  fetchCounters: async function ({ commit, dispatch }) {
    try {
      let data = await this.remoteRequest(
        "get",
        urls.counter,
        null,
        true,
        dispatch,
        "Számlálók letöltése...",
        null,
        true
      );
      commit("saveCounters", data);
    } catch (err) {
      if ("Cached!" !== err) {
        logger.error(err);
      }
    }
  }.bind(storeCore),
  startCounter: async function ({ commit, dispatch }, { issueId, override }) {
    try {
      const urlSearchParams = new URLSearchParams();
      urlSearchParams.append("override", override);
      await this.remoteRequest(
        "post",
        `${urls.counter}/${encodeURIComponent(
          issueId
        )}?${urlSearchParams.toString()}`,
        null,
        true,
        dispatch,
        "Számláló indítása..."
      );
    } catch (err) {
      if ("Cached!" !== err) {
        logger.error(err);
      }
    }
  }.bind(storeCore),
  stopCounter: async function ({ commit, dispatch }, id) {
    try {
      await this.remoteRequest(
        "put",
        `${urls.counter}`,
        null,
        true,
        dispatch,
        "Számláló leállítása..."
      );
    } catch (err) {
      if ("Cached!" !== err) {
        logger.error(err);
      }
    }
  }.bind(storeCore),
  closeDay: async function ({ commit, dispatch }, { date, worklogs }) {
    try {
      const urlSearchParams = new URLSearchParams();
      urlSearchParams.set("date", date);
      await this.remoteRequest(
        "post",
        `${urls.close}?${urlSearchParams.toString()}`,
        worklogs,
        true,
        dispatch,
        "Nap zárása..."
      );
    } catch (err) {
      if ("Cached!" !== err) {
        logger.error(err);
      }
    }
  }.bind(storeCore),
  clearCache: async function ({}) {
    this.clearCoreCache();
  }.bind(storeCore),
};

const mutations = {
  saveCounters: (state, data) => {
    state.counters = data;
  },
};

const getters = {
  getCounters: (state) => {
    return state.counters;
  },
};

export default {
  namespaced: true,
  state: initState(),
  mutations: mutations,
  actions: actions,
  getters: getters,
};
